import React from 'react'
import {Link,Navigate, useNavigate} from "react-router-dom"
import { useState } from 'react'
import axios from "axios"
import {schema} from "./constrains"
import { useFormik } from 'formik'
import './authStyles.css'
export default function Signup() {
  const navigate=useNavigate()

  const initialValues={
    username:"",
    email:"",
    password:"",
    confirmPassword:""
  }
  const {values,errors,handleBlur,handleChange,handleSubmit,touched}=useFormik({
    initialValues:initialValues,
    validationSchema:schema,
    onSubmit:async(value)=>{
      console.log(value)
      console.log(errors)
      await axios.post('http://localhost:5000/signup',{uname:value.username,email:value.email,password:value.password})
    }
  })


// const onsubmit=async (e)=>{
//   e.preventDefault()
//   console.log(username,email,password)
//   // fetch('http://localhost:3000/signup', {
//   //   method: 'POST',
//   //   headers: {
//   //     'Content-Type': 'application/json'
//   //   },
//   //   body: JSON.stringify({uname:username,eml:email,pword:password})
//   // })
//   //   .then(response => response.json())
//   //   .then(data => console.log(data))
//   //   .catch(error => console.error(error))
//   let response= await axios.post('http://localhost:5000/signup',{uname:username,eml:email,pword:password})
//   localStorage.setItem("users",JSON.stringify({uname:username,eml:email,pword:password}))
//   navigate('/')

// }
console.log(errors.name)
  return (
    <div>
       <div className="container">
      <div className="card">
        <div className="card_title">
          <h1>Create Account</h1>
          <span>Already have an account? <Link to='/signin'>Sign In</Link></span>
        </div>
        <div className="form">
        <form onSubmit={handleSubmit} >
          <input type="text" name="username" id="username" placeholder="UserName"  value={values.username} onChange={handleChange} onBlur={handleBlur}/>
          {errors.username&&touched.username?<p className='form-error'>{errors.username}</p>:null}
          <input type="email" name="email" placeholder="Email" id="email"  value={values.email} onChange={handleChange} onBlur={handleBlur}/>
          {errors.email&&touched.email?<p className='form-error'>{errors.email}</p>:null}
          <input type="password" name="password" placeholder="Password" id="password" value={values.password} onChange={handleChange} onBlur={handleBlur} />
          {errors.password&&touched.password?<p className='form-error'>{errors.password}</p>:null}
          <input type="password" name="confirmPassword" placeholder="Password" id="confirmPassword" value={values.confirmPassword} onChange={handleChange} onBlur={handleBlur} />
          {errors.confirmPassword&&touched.confirmPassword?<p className='form-error'>{errors.confirmPassword}</p>:null}
          <button type='submit'>Sign Up</button>
          </form>
        </div>
        <div className="card_terms">
            <input type="checkbox" name="" id="terms"/> <span>I have read and agree to the <a href="">Terms of Service</a></span>
        </div>
      </div>
    </div>
    </div>
  )
}
